import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEndRecordingSymbol = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1422_6029)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M8.84324 15.831C12.3627 15.831 15.2158 12.9779 15.2158 9.45847C15.2158 5.93902 12.3627 3.08594 8.84324 3.08594C5.32378 3.08594 2.4707 5.93902 2.4707 9.45847C2.4707 12.9779 5.32378 15.831 8.84324 15.831Z",
			stroke: "#BD0B0B",
			strokeWidth: 1.06209,
			strokeMiterlimit: 10
		}), /* @__PURE__ */ _jsx("path", {
			d: "M10.4368 7.86328H7.25049V11.0495H10.4368V7.86328Z",
			stroke: "#BD0B0B",
			strokeWidth: 1.06209,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1422_6029",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16.9934,
			height: 16.9934,
			fill: "white",
			transform: "translate(0.346191 0.960938)"
		})
	}) })]
});
export default SvgEndRecordingSymbol;
